import { SIGNUP_ROUTES } from '../../constants';

export interface Step {
  title: string,
  description: string,
  path: string,
}

export const Steps: Step[] = [
  {
    title: 'Select Plan',
    description: 'Select a plan that best suits you.',
    path: SIGNUP_ROUTES.BILLING,
  }, {
    title: 'Account Info',
    description: 'Please provide your name and email.',
    path: SIGNUP_ROUTES.ACCOUNT,
  }, {
    title: 'CAN-SPAM Compliance',
    description: 'Please provide your company information.',
    path: SIGNUP_ROUTES.CANSPAM,
  }, {
    title: 'Email Preferences',
    description: 'Manage email preferences for your account.',
    path: SIGNUP_ROUTES.EMAIL_PREFERENCES,
  },
]
